import React from 'react';
import { Link } from 'react-router-dom';
import { UserContext } from '../../../Application';
import { SIDEBAR } from '../../../constants/admin/sidebar';
import { ifPermission } from '../../../constants/authentication/permissions';

const SideBar = ({ hasContext, currentPath, contextSubject, subject }) => (
    <nav className="ckp-admin-sidebar">
        <UserContext.Consumer>
            {user => (
                <ul className="ckp-admin-sidebar-menu">
                    {(SIDEBAR || []).map(si => {
                        const id = si.label.toLowerCase().replace(' ', '-');
                        const link = (
                            <li
                                key={id}
                                className={`ckp-admin-sidebar-item ${hasContext && si.noContext ? 'u-hidden' : ''}`}
                            >
                                <Link
                                    className={`ckp-admin-sidebar-link is-${id} ${si.highlight(currentPath) ? 'is-highlighted' : ''}`}
                                    to={si.to(subject)}
                                >
                                    {si.label}
                                </Link>
                            </li>
                        );
                        if (si.permissionFunction) {
                            const allowed = si.permissionFunction(user, contextSubject);
                            return allowed ? link : null;
                        } else {
                            return ifPermission(
                                user,
                                hasContext ? si.requiredPermission : si.requiredPermissionAll,
                                link
                            );
                        }
                    })}
                </ul>
            )}
        </UserContext.Consumer>
    </nav>
);

export default SideBar;
